export default function useLotAttributes() {

  const tipoPagamentoValues = [
    { id: 'bonifico45ggDF', label: 'Bonifico Bancario 45 giorni D.F.' },
    { id: 'bonifico30ggDF', label: 'Bonifico Bancario 30 giorni D.F.' },
    { id: 'bonifico60ggDF', label: 'Bonifico Bancario 60 giorni D.F.' },
    { id: 'anticipato', label: 'Pagamento anticipato' },
    { id: 'fideiussione', label: 'Fideiussione bancaria' },
    { id: 'riba30ggDF', label: 'Ricevuta bancaria 30 giorni D.F.' },
    { id: 'riba45ggDF', label: 'Ricevuta bancaria 45 giorni D.F.' },
    { id: 'riba60ggDF', label: 'Ricevuta bancaria 60 giorni D.F.' },
    { id: 'rimessaDiretta', label: 'Rimessa diretta a ritiro merce' },
  ];

  const territorioInteresseValues = [
    { id: 'italia', label: 'Tutta Italia' },
    { id: 'nord', label: 'Nord' },
    { id: 'nordovest', label: 'Nord Ovest' },
    { id: 'nordest', label: 'Nord Est' },
    { id: 'centro', label: 'Centro' },
    { id: 'centronord', label: 'Centro Nord' },
    { id: 'centrosud', label: 'Centro Sud' },
    { id: 'sud', label: 'Sud' },
    { id: 'sudovest', label: 'Sud Ovest' },
    { id: 'sudest', label: 'Sud Est' },
    { id: 'sicilia', label: 'Sicilia' },
    { id: 'sardegna', label: 'Sardegna' },
  ]

  const provenienzaProdottoValues = [
    { id: 'selezioneRaccoltaDifferenziata', label: 'Selezione della raccolta differenziata ' }
  ]

  const tipologiaProdottoValues = [
    { id: 'postconsumo', label: 'Post Consumo' },
    { id: 'industriale', label: 'Industriale' }
  ]

  const statoFisicoValues = [
    { id: 'opachiColorati', label: 'Opachi Colorati' },
    { id: 'coloriMisti', label: 'Colori Misti' },
    { id: 'trasparentiAzzurrati', label: 'Trasparenti Azzurati' },
    { id: 'trasparentiIncolore', label: 'Trasparenti incolore' }
  ]

  const imballaggioValues = [
    { id: 'a10', label: 'Sino a 10 ton' },
    { id: 'da10a12', label: 'Da 10 ton a 12 ton' },
    { id: 'da12a14', label: 'Da 12 ton a 14 ton' },
    { id: 'da14a16', label: 'da 14 ton a 16 ton' },
    { id: 'da16a18', label: 'da 16 ton a 18 ton' },
    { id: 'da18a20', label: 'da 18 ton a 20 ton' },
    { id: 'da22a24', label: 'da 22 ton a 24 ton' },
    { id: 'da24a26', label: 'da 24 ton a 26 ton' },
    { id: 'da26', label: 'oltre 26 ton' },
  ]

  const qualitaMaterialeValues = [
    { id: 'conforme', label: 'Conforme alla Specifica' },
    { id: 'nonconforme', label: 'Non conforme alla Specifica' },
    { id: 'ottima', label: 'Ottima' },
    { id: 'buona', label: 'Buona' },
    { id: 'sufficiente', label: 'Sufficiente' },
    { id: 'scarsa', label: 'Scarsa' },
    { id: 'pessima', label: 'Pessima' },
  ]

  return { 
    imballaggioValues, 
    provenienzaProdottoValues, 
    qualitaMaterialeValues,
    statoFisicoValues,
    territorioInteresseValues,
    tipologiaProdottoValues,
    tipoPagamentoValues
  }
}